import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useSelector } from 'react-redux';
import { generateCashDownLabel } from '../common/utils';
import { GridItem, StyledTypography } from './styled.components';

export const CashDownCell = () => {
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const deductDueAtSigning = useSelector(dealerSelectors.getIsDueAtSigninAmountDeduct);
    const isTargetOutOfPocket = useSelector(offerReduxSelectors.getIsTargetOutOfPocket);
    const isOnePayLease = useSelector(offerReduxSelectors.isOnePayLease);
    const isEnhancedDealDetailsEnabled = useSelector(featureToggleSelectors.getEnhancedDealDetails);
    const isTargetOutOfPocketLeaseEnabled = useSelector(featureToggleSelectors.isTargetOutOfPocketLeaseEnabled);
    const isFlexBuyPayment = useSelector(offerReduxSelectors.isFlexBuyPayment);
    const isDueAtSigningEnhancementsEnabled = useSelector(featureToggleSelectors.enableDueAtSigningEnhancements);
    const isEquityAllocationOrderEnabled = useSelector(featureToggleSelectors.isEquityAllocationOrderEnabled);

    return (
        <GridItem
            xs={3}
            className="payment-grid-item"
            sx={{
                background: '#f4f4f4',
                alignSelf: 'stretch',
                minHeight: '80px',
                height: isFlexBuyPayment ? '128px' : 'auto'
            }}
        >
            <StyledTypography className="large" data-testid="cash-down-header" style={{ color: 'black' }}>
                {generateCashDownLabel(
                    offerType,
                    isOnePayLease ? false : deductDueAtSigning,
                    isTargetOutOfPocket,
                    isEnhancedDealDetailsEnabled,
                    isTargetOutOfPocketLeaseEnabled,
                    isDueAtSigningEnhancementsEnabled,
                    isEquityAllocationOrderEnabled
                )}
            </StyledTypography>
        </GridItem>
    );
};
